<template>
    <div
        class="card-border px-2 category-pill cursor-pointer center-y ion-text-center"
        style="padding-top: 2px; padding-bottom: 2px;"
        :class="{
            'highlight-bg-coral bs-coral-full light-light-color': !outline && !supplierCategory && !light && !purple,
            'bs-purple-full highlight-bg-octo-purple': supplierCategory,
            'bs-dashed': outline,
            'card-ripple-parent ion-activatable': !edit || ripple,
            'highlight-bg-corallight bs-corallight-full': light,
            'highlight-bg-purple bs-highlightpurple-full light-light-color': purple
         }"
    >
        <ion-ripple-effect v-if="(!edit && !disableRipple) || ripple" class="border-ripple"/>
        <div class="d-flex max-width">
            <div class="max-width" :class="{'overflow-ellipsis': !wrap, 'break-word': wrap}">
                <slot/>
            </div>

            <template v-if="edit">
                <div class="ion-activatable round-ripple-parent ml-1 center-y" @click="$emit('edit')">
                    <ion-icon :icon="pencilSharp"/>
                    <ion-ripple-effect/>
                </div>

                <div class="ion-activatable round-ripple-parent ml-1 center-y" @click="$emit('remove')">
                    <ion-icon :icon="close"/>
                    <ion-ripple-effect/>
                </div>
            </template>

            <template v-if="deleteAble">
                <div
                    class="ion-activatable round-ripple-parent ml-1 center-y"
                    @click="$event.stopPropagation(); $emit('delete')"
                >
                    <ion-icon :icon="trashOutline"/>
                    <ion-ripple-effect/>
                </div>
            </template>

            <template v-if="removeFilter">
                <div class="ion-activatable round-ripple-parent ml-1 center-y" @click="$emit('remove')">
                    <ion-icon :icon="close"/>
                    <ion-ripple-effect/>
                </div>
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import { IonRippleEffect, IonIcon } from "@ionic/vue";

import { CategoryPillProps } from "@/types/props";
import { CategoryPillEmits } from "@/types/emits";

import { pencilSharp, close, trashOutline } from "ionicons/icons";

defineProps<CategoryPillProps>()
defineEmits<CategoryPillEmits>()
</script>

<style scoped>
.category-pill {
    width: max-content;
    max-width: 250px;
    border-color: var(--ion-color-purple);
}

.bs-coral-full {
    border: 3px solid var(--ion-color-coral)
}

.bs-highlightpurple-full {
    border: 3px solid var(--color-highlight-purple);
}

.bs-corallight-full {
    border: 3px solid rgba(var(--ion-color-coral-rgb), 0) /*Needs to be 0 since background already has the correct color */
}

.bs-purple-full {
    border: 3px solid var(--ion-color-purple)
}

.border-ripple {
    width: calc(100% + 6px);
    height: calc(100% + 6px);
    margin-left: -3px;
    margin-top: -3px;
}
</style>